<div class="dvb-list-summary normal-abstand-top">
    <ng-transclude></ng-transclude>
</div>
